module.exports = __webpack_public_path__ + "static/media/logo.1fedb406.svg";